import {useTranslation} from '@/translations/i18n'
import {StyledToggleGroupEntityItem, StyledToggleGroupEntityRoot} from './style'
import {useController, useFormContext} from 'react-hook-form'
import {NewConversationFormValidationSchema} from '../../types'

export const ConversationEntityToggleGroup = () => {
    const {t} = useTranslation()
    const form = useFormContext()

    const entityList = [
        {
            value: 'project',
            label: t('commons:projects', {count: 1})
        },
        {
            value: 'treatment_request',
            label: t('commons:treatment_request')
        },
        {
            value: 'medical_record_report',
            label: t('global_search:medical_record')
        }
    ] as const satisfies {value: NonNullable<NewConversationFormValidationSchema['entityType']>; label: string}[]

    const {field} = useController({control: form.control, name: 'entityType'})

    const handleChange = (value: NonNullable<NewConversationFormValidationSchema['entityType']>) => {
        field.onChange(value)
        form.setValue('entity', null)
    }
    return (
        <StyledToggleGroupEntityRoot type="single" value={field.value} onValueChange={handleChange}>
            {entityList.map(entity => (
                <StyledToggleGroupEntityItem key={entity.value} value={entity.value} aria-label={entity.label}>
                    {entity.label}
                </StyledToggleGroupEntityItem>
            ))}
        </StyledToggleGroupEntityRoot>
    )
}
